import { useMemo } from 'react'

import { useTexts } from './useTexts'

export interface TerritoryDetails {
  id: string
  name: string
  hasAllVehicles: boolean
  hasAllDrivers: boolean
  vehicleIds: string[]
  driverIds: string[]
}

export function useTerritoriesDetails(
  courierFilter: uui.domain.client.rm.CourierFilter,
  territoryNames: Record<string, string>,
) {
  const texts = useTexts()

  const territoriesCount = Object.keys(courierFilter).length

  const territoriesDetails = useMemo<TerritoryDetails[]>(() => {
    const keys = Object.keys(courierFilter)

    const territoryDetails: TerritoryDetails[] = []

    for (const territoryId of keys) {
      const drivers = courierFilter[territoryId]?.driverIds ?? []
      const hasAllDrivers = drivers.includes('*')

      const vehicles = courierFilter[territoryId]?.vehicleIds ?? []
      const hasAllVehicles = vehicles.includes('*')

      territoryDetails.push({
        id: territoryId,
        name: territoryNames[territoryId] ?? '',
        hasAllDrivers,
        hasAllVehicles,
        vehicleIds: hasAllVehicles ? [] : vehicles,
        driverIds: hasAllDrivers ? [] : drivers,
      })
    }

    return territoryDetails
  }, [courierFilter, texts, territoryNames])

  return {
    territoriesCount,
    territoriesDetails,
  }
}
